import React from 'react'
import Svg from './..'

export interface ExclamationProps extends React.SVGProps<SVGSVGElement> {
  children: React.ReactNode
}

const Exclamation = ({ className, ...restProps }: ExclamationProps) => {
  return (
    <Svg
      viewBox='0 0 16 17'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      {...restProps}
    >
      <path
        d='M8.57143 6.66316V12.9489H7.42857V6.66316H8.57143ZM9 4.37744C9 4.91712 8.53968 5.37744 8 5.37744C7.46032 5.37744 7 4.91712 7 4.37744C7 3.83776 7.46032 3.37744 8 3.37744C8.53968 3.37744 9 3.83776 9 4.37744ZM14.8571 8.37744C14.8571 4.59966 11.7778 1.5203 8 1.5203C4.22222 1.5203 1.14286 4.59966 1.14286 8.37744C1.14286 12.1552 4.22222 15.2346 8 15.2346C11.7778 15.2346 14.8571 12.1552 14.8571 8.37744ZM16 8.37744C16 12.7901 12.4127 16.3774 8 16.3774C3.5873 16.3774 0 12.7901 0 8.37744C0 3.96474 3.5873 0.377441 8 0.377441C12.4127 0.377441 16 3.96474 16 8.37744Z'
        fill='#BBB2B7'
      />
    </Svg>
  )
}

export default Exclamation
